/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecutionPlanExpenseDto
 */
export interface ExecutionPlanExpenseDto {
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanExpenseDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanExpenseDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanExpenseDto
     */
    planId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanExpenseDto
     */
    taskId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanExpenseDto
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanExpenseDto
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanExpenseDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanExpenseDto
     */
    currency?: string;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanExpenseDto
     */
    expenseDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ExecutionPlanExpenseDto
     */
    approved?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanExpenseDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanExpenseDto
     */
    createdBy?: string;
}

/**
 * Check if a given object implements the ExecutionPlanExpenseDto interface.
 */
export function instanceOfExecutionPlanExpenseDto(value: object): value is ExecutionPlanExpenseDto {
    return true;
}

export function ExecutionPlanExpenseDtoFromJSON(json: any): ExecutionPlanExpenseDto {
    return ExecutionPlanExpenseDtoFromJSONTyped(json, false);
}

export function ExecutionPlanExpenseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutionPlanExpenseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'planId': json['planId'] == null ? undefined : json['planId'],
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'category': json['category'] == null ? undefined : json['category'],
        'description': json['description'] == null ? undefined : json['description'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'expenseDate': json['expenseDate'] == null ? undefined : (new Date(json['expenseDate'])),
        'approved': json['approved'] == null ? undefined : json['approved'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
    };
}

export function ExecutionPlanExpenseDtoToJSON(json: any): ExecutionPlanExpenseDto {
    return ExecutionPlanExpenseDtoToJSONTyped(json, false);
}

export function ExecutionPlanExpenseDtoToJSONTyped(value?: ExecutionPlanExpenseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'planId': value['planId'],
        'taskId': value['taskId'],
        'category': value['category'],
        'description': value['description'],
        'amount': value['amount'],
        'currency': value['currency'],
        'expenseDate': value['expenseDate'] == null ? undefined : ((value['expenseDate']).toISOString().substring(0,10)),
        'approved': value['approved'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'createdBy': value['createdBy'],
    };
}

